import type { ElementType, ReactNode } from 'react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { FontColorType } from '../../helpers';
import type { TextAlignment } from '../text/text-style-helpers';
import { HeadingStyles } from './heading.styles';

export interface HeadingProps extends CommonHTMLAttributes {
  as?: ElementType;
  children?: ReactNode;
  className?: string;
  color?: FontColorType;
  level?: 1 | 2 | 3;
  textAlign?: TextAlignment;
}

const HTML_TAG_MAP = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
};

export function Heading({ level = 1, color = 'default', textAlign = 'left', className, as, ...props }: HeadingProps) {
  const Component = !!as ? as : HTML_TAG_MAP[level];
  const style = HeadingStyles.heading({ textAlign, color, level });

  return <Component css={style} className={className} {...props} />;
}
